var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPencil = function SvgPencil(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6.39963L17.6001 9.5997M19.3393 7.84926C19.7623 7.42639 19.9999 6.85281 20 6.25471C20.0001 5.6566 19.7626 5.08296 19.3397 4.65999C18.9168 4.23701 18.3433 3.99934 17.7452 3.99927C17.1471 3.99919 16.5734 4.23672 16.1505 4.65959L5.47356 15.339C5.28781 15.5242 5.15045 15.7523 5.07356 16.003L4.01675 19.4847C3.99607 19.5539 3.99451 19.6274 4.01223 19.6974C4.02995 19.7674 4.06628 19.8313 4.11739 19.8823C4.16849 19.9334 4.23245 19.9696 4.30248 19.9872C4.37251 20.0048 4.446 20.0031 4.51515 19.9823L7.99758 18.9263C8.24812 18.8501 8.47613 18.7136 8.66159 18.5287L19.3393 7.84926Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pencil.b475046dc5a47c11219ade9d00dba4ed.svg";